import { ChangeRequestDtoTypeEnum } from "../../../api";

export type ChangeRequestType = ChangeRequestDtoTypeEnum;

const {
  SellerProfileUpdate,
  BuyerProfileUpdate,
  ProductUpdate,
  BankAccountCreate,
  BankAccountUpdate,
  BankAccountDelete,
} = ChangeRequestDtoTypeEnum;

export function isProfile(type: ChangeRequestType): boolean {
  return type === SellerProfileUpdate || type === BuyerProfileUpdate;
}

export function isProduct(type: ChangeRequestType): boolean {
  return type === ProductUpdate;
}

/**
 * Owner-facing label — for the user who owns the request.
 * The role prefix is dropped because the owner already knows who they are.
 */
export function humanizeTypeForOwner(type: ChangeRequestType): string {
  switch (type) {
    case SellerProfileUpdate:
    case BuyerProfileUpdate:
      return "Profile update";
    case ProductUpdate:
      return "Product update";
    case BankAccountCreate:
      return "New bank account";
    case BankAccountUpdate:
      return "Bank account update";
    case BankAccountDelete:
      return "Bank account removal";
    default:
      return type;
  }
}

/**
 * Admin-facing label — keeps the role prefix because admins triage across
 * both buyer and seller submissions and need the disambiguator.
 */
export function humanizeTypeForAdmin(type: ChangeRequestType): string {
  switch (type) {
    case SellerProfileUpdate:
      return "Seller profile update";
    case BuyerProfileUpdate:
      return "Buyer profile update";
    case ProductUpdate:
      return "Product update";
    case BankAccountCreate:
      return "New bank account";
    case BankAccountUpdate:
      return "Bank account update";
    case BankAccountDelete:
      return "Bank account removal";
    default:
      return type;
  }
}

/** @deprecated use `humanizeTypeForOwner` or `humanizeTypeForAdmin` explicitly. */
export const humanizeType = humanizeTypeForAdmin;
